export const constantSelectOptions = (constant) =>
  Object.keys(constant).map((x) => ({ value: x, label: constant[x] }));

export const orderedSelectOptions = (array) =>
  array.map((x, i) => ({ value: i, label: x }));

export const flatSelectOptions = (array) =>
  array.map((x, i) => ({ value: x, label: x }));
